var React = require('react');

function LanciauxInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"standard"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"standard","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","fontFamily":"Titillium-Regular, Titillium","fontSize":"118","fontWeight":"normal","letterSpacing":"1","key":2},React.createElement("g",{"id":"SPACESHIP-STUDIO","transform":"translate(-10.000000, -6.000000)","fill":"#E72A53"},React.createElement("text",null,React.createElement("tspan",{"x":"0","y":"89"},"Ryan Lanciaux"))))]);
}

LanciauxInline.defaultProps = {"width":"708px","height":"110px","viewBox":"0 0 708 110","version":"1.1"};

module.exports = LanciauxInline;

LanciauxInline.default = LanciauxInline;
